<div class="login-container">
  <div class="login-icon">
    <span>
      <i class="bi bi-person-workspace"></i>
    </span>
  </div>
  <div class="login-title">
    <h2>DATA ENTRY APPLICATION</h2>
  </div>
  <div class="login-form">
    <div class="alert bg-danger-subtle border-danger-subtle text-danger fs-14 text-center" *ngIf="error">{{error}}</div>

      <form [formGroup]="loginForm" class="de-login-form">
        <div class="de-form-group">
          <span class="de-label"><i class="bi bi-person-fill"></i> Username</span>
          <div class="de-field">
            <input type="text" formControlName="username" placeholder="Username" autocomplete="none">
          </div>
          <span class="de-error">
            <span *ngIf="(loginFormControl.username.touched || submitted) && loginFormControl.username.errors">
              <span *ngIf="loginFormControl.username.errors.required"
                   class="ui red left pointing prompt label transition visible">Username is required
              </span>
            </span>
          </span>
        </div>
        <div class="de-form-group">
          <span class="de-label"><i class="bi bi-lock-fill"></i> Password</span>
          <div class="de-field">
            <div class="input-group">
              <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Password" autocomplete="none" />
              <span class="input-group-text" (click)="togglePassword();" style="cursor: pointer;">
                <iconify [name]="'lucide:eye'"></iconify>
              </span>
            </div>
          </div>
          <span class="de-error">
            <span *ngIf="(loginFormControl.password.touched || submitted) && loginFormControl.password.errors">
              <span *ngIf="loginFormControl.password.errors.required"
                   class="ui red left pointing prompt label transition visible">Password is required</span>
            </span>
          </span>
        </div>
        <div class="de-form-group">
<!--          <button (click)="handleLogin()" [disabled]="(!(loginForm.valid || loading))">-->
<!--            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>-->
<!--            Login-->
<!--          </button>-->
          <button (click)="handleLogin()" [disabled]="!loginForm.valid || loading">
            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            Login
          </button>

        </div>
      </form>
  </div>

</div>


<!--<div _ngcontent-c0="" class="app-content ui basic segment container min pulse ">-->
<!--  <div _ngcontent-c3="" class="root pulse">-->
<!--    <h2 _ngcontent-c3="" class="ui image header center aligned">-->
<!--      <div _ngcontent-c3="" class="content" style="font-size: 10px;">-->
<!--        &lt;!&ndash; LOGIN &ndash;&gt;-->
<!--      </div>-->
<!--      <div style="width: 35%;-->
<!--      display: flex;-->
<!--      justify-content: center;-->
<!--      transform: translateX(202px) ;">-->
<!--      <img src="assets/images/dataEntryIcon.svg"/>-->

<!--      </div>-->
<!--      <div>DATA ENTRY APPLICATION</div>-->

<!--    </h2>-->

<!--    &lt;!&ndash;&ndash;&gt;-->

<!--    <form [formGroup]="loginForm" _ngcontent-c3="" class="ui large form ng-pristine ng-invalid ng-touched" novalidate=""-->
<!--      autocomplete="off">-->
<!--      <div class="ui red message" *ngIf="(errorMessage != '')" style="color: white;">-->
<!--        {{ errorMessage }}-->
<!--      </div>-->
<!--      <div _ngcontent-c3="" class="ui segment">-->
<!--        <div _ngcontent-c3="" class="field">-->
<!--          <div _ngcontent-c3="" class="ui left icon input">-->
<!--            <i _ngcontent-c3="" class="user icon"></i>-->
<!--            <input _ngcontent-c3="" formControlName="username" name="Username" placeholder="Username" type="text">-->
<!--            <div *ngIf="(loginFormControl.username.touched || submitted) && loginFormControl.username.errors">-->
<!--              <div *ngIf="loginFormControl.username.errors.required"-->
<!--                class="ui red left pointing prompt label transition visible">Username is required</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div _ngcontent-c3="" class="field">-->
<!--          <div _ngcontent-c3="" class="ui left icon input">-->
<!--            <i _ngcontent-c3="" class="lock icon"></i>-->
<!--            <input _ngcontent-c3="" formControlName="password" name="password" placeholder="Password" type="password">-->
<!--            <div *ngIf="(loginFormControl.password.touched || submitted) && loginFormControl.password.errors">-->
<!--              <div *ngIf="loginFormControl.password.errors.required"-->
<!--                class="ui red left pointing prompt label transition visible">Password is required</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; <span _ngcontent-c3="" class="forgot-password-link">Forgot password?-->
<!--            <a _ngcontent-c3="" [routerLink]="'/reset-password'">click here</a></span> &ndash;&gt;-->
<!--        </div>-->

<!--        <button (click)="handleLogin()" [disabled]="(loginForm.valid || loading) ? false : true" _ngcontent-c3=""-->
<!--          class="ui fluid large primary submit button">-->
<!--          <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="loading"></i>-->
<!--          Login-->
<!--        </button>-->

<!--      </div>-->
<!--    </form>-->
<!--  </div>-->

<!--</div>-->
